<template>
    <div class="columns is-centered">
        <div class="column is-three-quarters">
            <nav v-if="pagination.total_pages > 1">
                <ul class="pagination">
                    <li :class="['page-item', { disabled: !pagination.links.previous }]" aria-label="« Previous">
                        <span v-if="!pagination.links.previous" class="page-link" aria-hidden="true">‹</span>
                        <a v-else class="page-link" @click.prevent="changePage(getPageNumber(pagination.links.previous))">‹</a>
                    </li>

                    <li v-for="(link, index) in generatePageLinks()" 
                        :key="index"
                        :class="['page-item', { active: pagination.current_page === link.page }]">
                        <span v-if="link.page === null" class="page-link">…</span>
                        <span v-else-if="pagination.current_page === link.page" class="page-link">{{ link.label }}</span>
                        <a v-else class="page-link" @click.prevent="changePage(link.page)">
                            {{ link.label }}
                        </a>
                    </li>

                    <li :class="['page-item', { disabled: !pagination.links.next }]" aria-label="Next »">
                        <span v-if="!pagination.links.next" class="page-link" aria-hidden="true">›</span>
                        <a v-else class="page-link" @click.prevent="changePage(getPageNumber(pagination.links.next))">›</a>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
  props: {
    pagination: {
      type: Object,
      required: true
    },
    max_visible_pages: {
      type: Number,
      default: 7
    }
  },
  methods: {
    getPageNumber(url) {
      if (!url) return null;
      const url_params = new URL(url, window.location.origin).searchParams;
      return Number(url_params.get('page')) || 1;
    },
    changePage(page) {
      if (!page || page === this.pagination.current_page) return;
      this.$emit('page-change', page);
    },
    generatePageLinks() {
      const links = [];
      const current_page = this.pagination.current_page;
      const last_page = this.pagination.total_pages;
      const max_pages = this.max_visible_pages;

      if (last_page <= max_pages + 3) {
        for (let i = 1; i <= last_page; i++) {
          links.push({ label: i, page: i });
        }
      } else {
        links.push({ label: 1, page: 1 });
        if (current_page > Math.ceil(max_pages / 2) + 1) {
          links.push({ label: '...', page: null });
        }

        let start_page = Math.max(2, current_page - Math.floor(max_pages / 2));
        let end_page = Math.min(last_page - 1, current_page + Math.floor(max_pages / 2));

        if (current_page <= Math.ceil(max_pages / 2)) {
          start_page = 2;
          end_page = max_pages;
        }
        if (current_page >= last_page - Math.ceil(max_pages / 2)) {
          start_page = last_page - (max_pages - 1);
          end_page = last_page - 1;
        }
        for (let i = start_page; i <= end_page; i++) {
          links.push({ label: i, page: i });
        }
        if (current_page < last_page - Math.ceil(max_pages / 2)) {
          links.push({ label: '...', page: null });
        }
        links.push({ label: last_page, page: last_page });
      }

      return links;
    }
  }
};
</script>